var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "akar-icons:money"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.70898 14.0098C4.70898 12.9489 5.13041 11.9315 5.88056 11.1813C6.6307 10.4312 7.64812 10.0098 8.70898 10.0098H40.709C41.7699 10.0098 42.7873 10.4312 43.5374 11.1813C44.2876 11.9315 44.709 12.9489 44.709 14.0098V34.0098C44.709 35.0706 44.2876 36.088 43.5374 36.8382C42.7873 37.5883 41.7699 38.0098 40.709 38.0098H8.70898C7.64812 38.0098 6.6307 37.5883 5.88056 36.8382C5.13041 36.088 4.70898 35.0706 4.70898 34.0098V14.0098Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.709 30.0098C28.0227 30.0098 30.709 27.3235 30.709 24.0098C30.709 20.6961 28.0227 18.0098 24.709 18.0098C21.3953 18.0098 18.709 20.6961 18.709 24.0098C18.709 27.3235 21.3953 30.0098 24.709 30.0098Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.70898 18.0098C6.83072 18.0098 8.86555 17.1669 10.3658 15.6666C11.8661 14.1663 12.709 12.1315 12.709 10.0098M36.709 38.0098C36.709 35.888 37.5518 33.8532 39.0521 32.3529C40.5524 30.8526 42.5873 30.0098 44.709 30.0098",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOutline);
export default __webpack_public_path__ + "static/media/camera-outline.c9601c8afd80faaca2a905de36570cd2.svg";
export { ForwardRef as ReactComponent };